<dx-popup
    #renameWorkspacePopup
    width="30%"
    height="20%"
    title="Save Custom Workspace"
    [showCloseButton]="true"
    [shading]="false"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [(visible)]="visible"
    (onShown)="onPopUpShown()"
    (onHidden)="onPopUpClose()"
>
    <div *dxTemplate="let data of 'content'">
        <dx-box width="100%" height="100%" direction="col">
            <dxi-item [ratio]="1">
                <dx-form width="100%" height="100%">
                    <dxi-item [isRequired]="true">
                        <dxo-label text="Name"></dxo-label>
                        <div *dxTemplate>
                            <dx-text-box [(value)]="workspaceName"></dx-text-box>
                        </div>
                    </dxi-item>
                </dx-form>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <dx-toolbar width="100%">
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Cancel"
                                    hint="Cancel"
                                    [icon]="iconCancel"
                                    (onClick)="onPopUpClose()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-button
                                    type="success"
                                    text="Save"
                                    hint="Save"
                                    [icon]="iconSave"
                                    (onClick)="onSave()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<cc-message-box #messageBox></cc-message-box>
